import { flattenObjectByPrecedenceForAuthStorage } from './flattenObjectByPrecedenceForAuthStorage'

export function flattenDataFromResponse(response) {
  let flattenedData = flattenObjectByPrecedenceForAuthStorage(response)
  if (response.productStates) {
    flattenedData = Object.assign({}, flattenedData, response.productStates[0])
  }
  if (response.goals) {
    flattenedData = Object.assign({}, flattenedData, { goals: response.goals })
  }
  return flattenedData
}
